import React, { useEffect } from 'react';
import { noop, udExternalLoaders } from '@udemy/shared-utils';
export const GoogleOneTap = ({
  googleClientId
}) => {
  useEffect(() => {
    // Google One Tap will automatically initialize when the script loads
    udExternalLoaders.loadGoogleAuth(noop);
  }, []);

  // Get `next` value from the url or use the current path as default
  const nextUri = encodeURIComponent(new URLSearchParams(window.location.search).get('next') || window.location.pathname);
  const loginUri = `${window.location.origin}/join/social-complete/google-one-tap/?next=${nextUri}`;
  return /*#__PURE__*/React.createElement("div", {
    id: "g_id_onload",
    "data-testid": "g_id_onload",
    "data-client_id": googleClientId,
    "data-login_uri": loginUri
  });
};
//# sourceMappingURL=google-one-tap.react.component.js.map